import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from 'material-ui/styles';
import TextField from 'material-ui/TextField';
import Tooltip from 'material-ui/Tooltip';
import MuiButton from 'material-ui/Button';

import DialogModal from '../../common/DialogModal';
import Button from '../../Parts/Button'
import NotificationBar from '../../Parts/NotificationBar.jsx'
import { DialogType } from '../../../constants/ComponentTypes';
import { numHyphen, validateNgItem } from '../../../utils/validator';
import AddressBookUtil from '../utils/AddressBookUtil'

const styles = () => ({
  paper: {
    maxHeight: 'unset',
    background: "#F4F6F9",
    width: '600px',
  },

  contentContainer: {
    padding: '25px',
    margin: 0,
  },

  container: {
    background: '#FFFFFF',
    border: '1px solid #D8DBDF',
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
  },

  row: {
    marginTop: '20px',
    width: '100%',
    display: 'flex',
    alignItems: 'flex-end',
    flexDirection: 'row',
    justifyContent: 'center',
  },

  subRow: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-end',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },

  linkBtn: {
    border: 'none',
    minWidth: 'unset',
    width: 'unset',
    minHeight: 'unset',
    height: 'unset',
    padding: '0px 5px',
    marginTop: '5px',
    fontSize: '11px',
    color: '#1A65FF',
    textDecoration: 'underline',
  },

  tooltip: {
    backgroundColor: '#d32f2f',
    width: '100%',
    maxWidth: '335px',
  },

  input: {
    boxSizing: 'border-box',
  },
});

class EditNgItemDialog extends React.Component {
  initialState = {
    item: {
      name: '',
      corporate_number: '',
    },
    error: {},
    errorMessage: '',
    saveBtnPressed: false,
  }

  constructor(props) {
    super(props);
    if (props.type === DialogType.CREATE) {
      this.state = { ...this.initialState };
    } else {
      this.state = {
        ...this.initialState,
        item: AddressBookUtil.makeNgItem(props.item)
      };
    }
  }

  componentWillReceiveProps(nextProps) {
    //close dialog when API succeeds
    if (this.props.isSaving && nextProps.isSaving === false && nextProps.error === null) {
      nextProps.toggleDialog();
    }

    if (!this.props.error && nextProps.error) {
      if (typeof nextProps.error === 'string') {
        this.setState({
          errorMessage: nextProps.error,
        })
      } else if (typeof nextProps.error === 'object') {
        this.setState({
          error: nextProps.error,
          errorMessage: "登録に失敗しました。",
        })
      }
    }
  }

  handleChange = property => e => {
    let item = { ...this.state.item };
    let value = e.target.value;

    if (property === "corporate_number") value = numHyphen(value);
    item[property] = value;

    this.setState({
      item: item,
      errorMessage: '',
    }, () => {
      // ２回目からタイピングごとでチェック
      if (this.state.saveBtnPressed) {
        this.validateForm();
      }
    })
  }

  handleSave = () => {
    if (!this.state.saveBtnPressed) this.validateForm();
    this.setState({
      saveBtnPressed: true,
    }, () => {
      if (this.countErrors() === 0) {
        let item = this.state.item;
        if (this.props.type === DialogType.CREATE) {
          this.props.postNgSendings({ 'ng_sendings': [item] });
        } else if (this.props.type === DialogType.EDIT) {
          this.props.putNgSendings(item);
        }
      }
    })
  }

  openHoujinSite = () => {
    window.open(process.env.REACT_APP_HOUJIN_BANGOU_SITE_URL);
  }

  validateForm = () => {
    let { item } = this.state;
    this.setState({
      error: validateNgItem(item),
    })
  }

  countErrors = () => {
    return Object.keys(this.state.error).length;
  }

  render() {
    const { classes, toggleDialog, isOpen, isSaving, title } = this.props;
    const { error, item } = this.state;

    return (
      <DialogModal
        title={title}
        open={isOpen}
        onClose={toggleDialog}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer
        }}
      >

        <NotificationBar
          message={this.state.errorMessage ? this.state.errorMessage : "法人番号・氏名の入力間違いにご注意ください。"}
          type={this.state.errorMessage ? "error" : "ghost"}
          open={true}
          autoClose={false}
          disableOnclickListener={true}
          style={{ marginBottom: '25px', boxShadow: 'none', fontWeight: 'normal' }}
          animation="none"
        >
        </NotificationBar>

        <div className={classes.container}>
          <div className={classes.row}>
            <Tooltip
              classes={{ tooltip: classes.tooltip }}
              style={{ width: '100%' }}
              placement="top-start"
              title={error["corporate_number"] ? error["corporate_number"] : ""}
            >
              <TextField
                id="corporate_number"
                value={item["corporate_number"]}
                label="法人番号"
                InputProps={{
                  disableUnderline: true,
                }}
                InputLabelProps={{ shrink: true, }}
                placeholder="法人番号を入力"
                onChange={this.handleChange("corporate_number")}
                onFocus={this.handleFocus}
                onBlur={this.handleBlur}
                error={error.hasOwnProperty("corporate_number")}
                className={classes.input}
                fullWidth
              />
            </Tooltip>
          </div>
          <div className={classes.subRow}>
            <MuiButton
              color="primary"
              className={classes.linkBtn}
              onClick={this.openHoujinSite}>
              国税庁HPで法人番号を検索
            </MuiButton>
          </div>

          <div className={classes.row} style={{ paddingRight: '0px' }}>
            <Tooltip
              classes={{ tooltip: classes.tooltip }}
              style={{ width: '100%' }}
              placement="top-start"
              title={error["name"] ? error["name"] : ""}
            >
              <TextField
                id="name"
                value={item["name"]}
                label="氏名（任意）"
                InputProps={{
                  disableUnderline: true,
                }}
                InputLabelProps={{ shrink: true, }}
                placeholder="氏名を入力"
                onChange={this.handleChange("name")}
                onFocus={this.handleFocus}
                onBlur={this.handleBlur}
                error={error.hasOwnProperty("name")}
                className={classes.input}
                fullWidth
              />
            </Tooltip>
          </div>

          <Button
            text="保存"
            handleClickButton={this.handleSave}
            loading={isSaving}
            disabled={this.countErrors() > 0}
            style={{ marginTop: '50px', marginBottom: '60px' }}
          />
        </div>
      </DialogModal>
    );
  }
}

EditNgItemDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  postNgSendings: PropTypes.func,
  putNgSendings: PropTypes.func,
  title: PropTypes.string,
  type: PropTypes.number,
  item: PropTypes.object,
  isSaving: PropTypes.bool,
  error: PropTypes.any,
};

EditNgItemDialog.defaultProps = {
  title: "送付NGを新規登録",
  type: DialogType.CREATE,
}

export default withStyles(styles)(EditNgItemDialog);



// WEBPACK FOOTER //
// ./src/components/AddressBook/dialogs/EditNgItemDialog.jsx